<template>
  <!---if on mobile and show more is disabled--->
  <div v-if="isMobile() && !showMore">
    <div v-if="runnerName">
      <v-simple-table
        dense
        v-if="runnerHasPastStartsDO(runnerTabNo)"
        style="width: 100%;"
      >
        <thead>
          <tr class="tableHeaders">
            <th style="font-weight: bold; color: black; font-size: 10px">
              <div>
                Placing
              </div>
              <div>
                Margin
              </div>
            </th>
            <th style="font-weight: bold; color: black; font-size: 10px">
              <div>
                Venue
              </div>
              <div>
                Class
              </div>
            </th>
            <th v-if="!harnessMeeting(race)" style="font-weight: bold; color: black; font-size: 10px">
              <div>
                Dist.
              </div>
              <div>
                Time
              </div>
            </th>
            <th v-if="harnessMeeting(race)" style="font-weight: bold; color: black; font-size: 10px">
              <div>
                Dist.
              </div>
              <div>
                SP
              </div>
            </th>
            <th v-if="harnessMeeting(race)" style="font-weight: bold; color: black; font-size: 10px">
              <div>
                Time
              </div>
              <div>
                Days
              </div>
            </th>
            <th v-if="!greyhoundMeeting(race) && !thoroughbredMeeting(race)" style="font-weight: bold; color: black; font-size: 10px">
              <div v-if="!harnessMeeting(race)">
                Jockey
              </div>
              <div v-else>
                Driver
              </div>
              <div v-if="!harnessMeeting(race)">
                In-Run
              </div>
              <div v-else>
                Barrier
              </div>
            </th>
            <th v-if="!greyhoundMeeting(race) && !harnessMeeting(race)" style="font-weight: bold; color: black; font-size: 10px">
              <div v-if="!harnessMeeting(race)">
                Cond.
              </div>
              <div>
                SP
              </div>
            </th>
            <th v-if="thoroughbredMeeting(race)" style="font-weight: bold; color: black; font-size: 10px">
              <div v-if="!harnessMeeting(race)">
                Jockey
              </div>
              <div v-else>
                Driver
              </div>
              <div v-if="!harnessMeeting(race)">
                In-Run
              </div>
              <div v-else>
                Barrier
              </div>
            </th>
            <th v-if="greyhoundMeeting(race)" style="font-weight: bold; color: black; font-size: 10px">
              <div>
                SP
              </div>
              <div>
                In Run
              </div>
            </th>
            <th v-if="greyhoundMeeting(race)" style="font-weight: bold; color: black; font-size: 10px">
              <div>
                Winner
              </div>
              <div>
                Date
              </div>
            </th>
          </tr>
        </thead>
        <tr style="background-color: #f2f2f2">
          <td style="text-align: center" colspan="5" v-if="findSpellCurrent(runnerForm) && findSpellCurrent(runnerForm) >= 42 && !greyhoundMeeting(race)">
            <b style="color: grey; font-size: 10px !important;">---{{findSpellCurrent(runnerForm)}} DAY {{checkSpell(findSpellCurrent(runnerForm))}}---</b>
          </td>
        </tr>
        <tbody
          v-for="(b, index) in mutateDataForm(runnerForm)"
          :key="index"
        >
        <!-- Show if there aren't any stewards comments -->
          <tr style="padding-bottom: 2px;" :class="formClassSet(b.isTrial)" v-if="!b.stewardsComment || harnessMeeting(race) || greyhoundMeeting(race)">
            <td
              style="font-size: 10px"
            >
              <div style="font-weight:bold">
                <span v-if="b.finishingPosition === 1" style="font-weight:bold">{{b.finishingPosition}}</span><span v-else>{{b.finishingPosition}}</span> / {{b.starters}}
              </div>
              <div style="font-weight:bold" v-if="race.meeting.type !== 'HARNESS'">
                {{Math.abs(b.margin)}}L
              </div>
              <div style="font-weight:bold" v-if="race.meeting.type === 'HARNESS'">
                {{Math.abs(b.margin)}}m
              </div>
              <div v-if="!greyhoundMeeting(race)" style="white-space: nowrap">
                {{format(new Date(b.date), 'dd-MM-yy')}}
              </div>
              <div v-if="greyhoundMeeting(race)">
                Box: {{b.barrier}}
                <div v-if="race.meeting.type === 'GREYHOUND' && race.meeting.track.country === 'GBR' && b.barrier" style="zoom:0.4;display:inline-block;float:left;width:28px;margin-top:5px;margin-right:5px;margin-left:2px;overflow:hidden;" :class="['greyhoundSpriteUk-' + b.barrier]" />
                <div v-if="race.meeting.type === 'GREYHOUND' && race.meeting.track.country === 'AUS' || race.meeting.type === 'GREYHOUND' && race.meeting.track.country === 'NZL' && b.barrier" style="zoom:0.4;display:inline-block;float:left;width:28px;margin-top:5px;margin-right:5px;margin-left:2px;overflow:hidden;" :class="['greyhoundSpriteAUS-' + b.barrier]" />
                <div v-if="race.meeting.type === 'GREYHOUND' && race.meeting.track.country === 'USA' || race.meeting.track.country === 'MEX' && b.barrier" style="zoom:0.4;display:inline-block;float:left;width:28px;margin-top:5px;margin-right:5px;margin-left:2px;overflow:hidden;" :class="['greyhoundSpriteUs-' + b.barrier]" />
              </div>
            </td>
            <td
              style="font-size: 10px"
            >
              <div style="font-weight:bold">
                {{b.track}}
              </div>
              <div style="max-width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
                {{checkClass(b.class)}}
              </div>
              <div
                v-if="!b.isTrial"
                style="font-size: 10px">
                ${{numeral(b.prizeTotal).format('0,0')}}
              </div>
              <div v-else>
                -
              </div>
            </td>
            <td
              style="font-size: 10px"
            >
              <div style="font-weight:bold">
                {{b.distance}}m
              </div>
              <div v-if="!harnessMeeting(race)">
                {{formatToMinutes(b.elapsedTime)}}
              </div>
              <div v-if="harnessMeeting(race)">
                ${{b.startingPrice.toFixed(2)}}
              </div>
              <div v-if="!harnessMeeting(race)">
                Days: {{b.dsls || '-'}}
              </div>
            </td>
            <td
              v-if="!greyhoundMeeting(race) && !thoroughbredMeeting(race)"
              style="font-size: 10px"
            >
              <div v-if="!harnessMeeting(race)">
                {{b.jockey}} {{!harnessMeeting(race) ? `(${b.weight}kg)` : ''}}
              </div>
              <div v-if="!greyhoundMeeting(race) && !harnessMeeting(race)">
                In-Run: {{formatInRun(b.inRun) || '-'}}
              </div>
              <div v-if="!harnessMeeting(race)">
                1st: {{findWinnerForm(b) || `${runnerName.name} (${b.weight}kg)`}}
              </div>
              <div v-if="harnessMeeting(race)">
                {{formatToMinutes(b.elapsedTime)}}
              </div>
              <div v-if="harnessMeeting(race)">
                Days: {{b.dsls || '-'}}
              </div>
              <div v-if="harnessMeeting(race)">
                In-Run: {{formatInRun(b.inRun) || '-'}}
              </div>
            </td>
            <td
              v-if="!greyhoundMeeting(race) && !b.track.includes('Synthetic')"
             style="font-size: 10px">
              <div
                v-if="!harnessMeeting(race)"
                style="font-size: 10px"
                :class="['color-' + checkTrackCond(b.trackCondition)]">
                <b v-if="b.trackCondition === 'Unknown'">-</b>
                <b v-else>{{checkTrackCond(b.trackCondition)}}</b>
              </div>
              <div v-if="harnessMeeting(race)">
                {{b.jockey}} {{!harnessMeeting(race) ? `(${b.weight}kg)` : ''}}
              </div>
              <div
                v-if="!b.isTrial && !harnessMeeting(race)" style="font-size: 10px;">
                ${{b.startingPrice.toFixed(2)}}
              </div>
              <div v-else-if="!harnessMeeting(race)"> - </div>
              <div v-if="!harnessMeeting(race) && !thoroughbredMeeting(race)">
                {{formatInRun(b.inRun) || '-'}}
              </div>
              <div v-if="harnessMeeting(race) || thoroughbredMeeting(race)">
                Bar: {{b.barrier}}
              </div>
            </td>
            <td
              v-else-if="!greyhoundMeeting(race) && b.track.includes('Synthetic')"
              style="font-size: 10px">
              <div
                style="font-size: 10px"
                :class="['color-Synthetic']">
                <b>Synthetic</b>
              </div>
              <div
                v-if="!b.isTrial" style="font-size: 10px;">
                ${{b.startingPrice.toFixed(2)}}
              </div>
              <div v-else> - </div>
              <div>
                {{formatInRun(b.inRun) || '-'}}
              </div>
            </td>
            <td
              v-if="greyhoundMeeting(race)"
              style="font-size: 10px">
              <div
                v-if="!b.isTrial" style="font-size: 10px;">
                ${{b.startingPrice.toFixed(2)}}
              </div>
              <div v-else> - </div>
              <div>
                {{formatInRun(b.inRun) || '-'}}
              </div>
            </td>
            <td
              v-if="greyhoundMeeting(race)"
              style="font-size: 10px">
              <div>
                1st: {{findWinnerFormGrey(b) || `${runnerName.name}`}}
              </div>
              <div style="white-space: nowrap">
                {{format(new Date(b.date), 'dd-MM-yy')}}
              </div>
            </td>
            <td
              v-if="thoroughbredMeeting(race)"
              style="font-size: 10px"
            >
              <div v-if="!harnessMeeting(race)">
                {{b.jockey}} {{!harnessMeeting(race) ? `(${b.weight}kg)` : ''}}
              </div>
              <div v-if="!greyhoundMeeting(race) && !harnessMeeting(race)">
                In-Run: {{formatInRun(b.inRun) || '-'}}
              </div>
              <div v-if="!harnessMeeting(race)">
                1st: {{findWinnerForm(b) || `${runnerName.name} (${b.weight}kg)`}}
              </div>
              <div v-if="harnessMeeting(race)">
                {{formatToMinutes(b.elapsedTime)}}
              </div>
              <div v-if="harnessMeeting(race)">
                Days: {{b.dsls || '-'}}
              </div>
              <div v-if="harnessMeeting(race)">
                In-Run: {{formatInRun(b.inRun) || '-'}}
              </div>
            </td>
          </tr>
          <!-- Show if there is a stewards comment -->
          <tr style="padding-bottom: 2px;" :class="formClassSet(b.isTrial)" v-if="b.stewardsComment && !harnessMeeting(race) && !greyhoundMeeting(race)">
            <td
              class="stewardsComment"
              style="font-size: 10px"
            >
              <div style="font-weight:bold">
                <span v-if="b.finishingPosition === 1" style="font-weight:bold">{{b.finishingPosition}}</span><span v-else>{{b.finishingPosition}}</span> / {{b.starters}}
              </div>
              <div style="font-weight:bold" v-if="race.meeting.type !== 'HARNESS'">
                {{Math.abs(b.margin)}}L
              </div>
              <div style="font-weight:bold" v-if="race.meeting.type === 'HARNESS'">
                {{Math.abs(b.margin)}}m
              </div>
              <div style="white-space: nowrap">
                {{format(new Date(b.date), 'dd-MM-yy')}}
              </div>
            </td>
            <td
              class="stewardsComment"
              style="font-size: 10px"
            >
              <div style="font-weight:bold">
                {{b.track}}
              </div>
              <div style="max-width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
                {{checkClass(b.class)}}
              </div>
              <div
                v-if="!b.isTrial"
                style="font-size: 10px">
                ${{numeral(b.prizeTotal).format('0,0')}}
              </div>
              <div v-else>
                -
              </div>
            </td>
            <td
              class="stewardsComment"
              style="font-size: 10px"
            >
              <div style="font-weight:bold">
                {{b.distance}}m
              </div>
              <div>
                {{formatToMinutes(b.elapsedTime)}}
              </div>
              <div>
                Days: {{b.dsls || '-'}}
              </div>
            </td>
            <td
              v-if="!greyhoundMeeting(race) && !thoroughbredMeeting(race)"
              class="stewardsComment"
              style="font-size: 10px"
            >
              <div>
                {{b.jockey}} ({{b.weight}}kg)
              </div>
              <div v-if="!greyhoundMeeting(race)">
                In-Run: {{formatInRun(b.inRun) || '-'}}
              </div>
              <div v-if="greyhoundMeeting(race)">
                Box: {{b.barrier}}
              </div>
              <div>
                1st: {{findWinnerForm(b) || `${runnerName.name} (${b.weight}kg)`}}
              </div>
            </td>
            <td
              v-if="!greyhoundMeeting(race) && !b.track.includes('Synthetic')"
              class="stewardsComment"
              style="font-size: 10px">
              <div
                v-if="!harnessMeeting(race)"
                style="font-size: 10px"
                :class="['color-' + checkTrackCond(b.trackCondition)]">
                <b v-if="b.trackCondition === 'Unknown'">-</b>
                <b v-else>{{checkTrackCond(b.trackCondition)}}</b>
              </div>
              <div
                v-if="!b.isTrial" style="font-size: 10px;">
                ${{b.startingPrice.toFixed(2)}}
              </div>
              <div v-else> - </div>
              <div v-if="!thoroughbredMeeting(race)">
                {{formatInRun(b.inRun) || '-'}}
              </div>
              <div v-else>
                Bar: {{b.barrier}}
              </div>
            </td>
            <td
              v-else-if="!greyhoundMeeting(race) && b.track.includes('Synthetic')"
              class="stewardsComment"
              style="font-size: 10px">
              <div
                style="font-size: 10px"
                :class="['color-Synthetic']">
                <b>Synthetic</b>
              </div>
              <div
                v-if="!b.isTrial" style="font-size: 10px;">
                ${{b.startingPrice.toFixed(2)}}
              </div>
              <div v-else> - </div>
              <div>
                {{formatInRun(b.inRun) || '-'}}
              </div>
            </td>
            <td
              v-if="greyhoundMeeting(race)"
              style="font-size: 10px">
              <div>
                Box: {{b.barrier}}
              </div>
              <div
                v-if="!b.isTrial" style="font-size: 10px;">
                ${{b.startingPrice.toFixed(2)}}
              </div>
              <div v-else> - </div>
              <div>
                1st: {{findWinnerFormGrey(b) || `${runnerName.name}`}}
              </div>
              <div v-if="!thoroughbredMeeting(race)">
                {{formatInRun(b.inRun) || '-'}}
              </div>
              <div v-else>
                Bar: {{b.barrier}}
              </div>
            </td>
            <td
              v-if="thoroughbredMeeting(race)"
              class="stewardsComment"
              style="font-size: 10px"
            >
              <div>
                {{b.jockey}} ({{b.weight}}kg)
              </div>
              <div v-if="!greyhoundMeeting(race)">
                In-Run: {{formatInRun(b.inRun) || '-'}}
              </div>
              <div v-if="greyhoundMeeting(race)">
                Box: {{b.barrier}}
              </div>
              <div>
                1st: {{findWinnerForm(b) || `${runnerName.name} (${b.weight}kg)`}}
              </div>
            </td>
          </tr>
          <tr v-if="b.stewardsComment && !harnessMeeting(race) && !greyhoundMeeting(race)">
            <td style="font-size: 10px;" colspan="5">
              Stewards: {{b.stewardsComment}}
            </td>
          </tr>
          <tr style="background-color: #f2f2f2">
            <td style="text-align: center" colspan="5" v-if="b.dsls && b.dsls >= 42 && !greyhoundMeeting(race)">
              <b style="color: grey; font-size: 10px !important;">---{{b.dsls}} DAY {{checkSpell(b.dsls)}}---</b>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <div class="text-center" v-else>
        <b style="color: grey; font-size: 18px !important;">FIRST START</b>
      </div>
      <!-- <div class="mt-1">
        <v-btn
          dark
          small
          class="primaryCol"
          style="margin-left: 2%; margin-right: 2%"
          width="96%"
          @click="showMore = true"
          v-if="runnerHasPastStartsDO(runnerTabNo) && showAllDataForm(runnerForm).length > 10">
          Show More ({{numberOfStarts(runnerForm)}})
        </v-btn>
      </div> -->
    </div>
  </div>
  <!--If on mobile and show more is enabled-->
  <div v-else-if="isMobile() && showMore">
    <div v-if="runnerName">
      <v-simple-table
        dense
        v-if="runnerHasPastStartsDO(runnerTabNo)"
        style="width: 100%;"
      >
        <thead>
        <tr class="tableHeaders">
          <th style="font-weight: bold; color: black; font-size: 10px">
            <div>
              Placing
            </div>
            <div>
              Margin
            </div>
          </th>
          <th style="font-weight: bold; color: black; font-size: 10px">
            <div>
              Venue
            </div>
            <div>
              Class
            </div>
          </th>
          <th style="font-weight: bold; color: black; font-size: 10px">
            <div>
              Dist.
            </div>
            <div>
              Time
            </div>
          </th>
          <th v-if="!greyhoundMeeting(race)" style="font-weight: bold; color: black; font-size: 10px">
            <div>
              Jockey
            </div>
            <div>
              Winner
            </div>
          </th>
          <th v-if="!greyhoundMeeting(race)" style="font-weight: bold; color: black; font-size: 10px">
            <div>
              Cond.
            </div>
            <div>
              SP
            </div>
          </th>
          <th v-if="greyhoundMeeting(race)" style="font-weight: bold; color: black; font-size: 10px">
            <div>
              Winner
            </div>
            <div>
              SP
            </div>
          </th>
        </tr>
        </thead>
        <tr>
          <td style="text-align: center" colspan="5" v-if="findSpellCurrent(runnerForm) && findSpellCurrent(runnerForm) >= 42">
            <b style="color: grey; font-size: 10px !important;">---{{findSpellCurrent(runnerForm)}} DAY {{checkSpell(findSpellCurrent(runnerForm))}}---</b>
          </td>
        </tr>
        <tbody
          v-for="(b, index) in showAllDataForm(runnerForm)"
          :key="index"
        >
        <!-- Show if there aren't any stewards comments -->
        <tr style="padding-bottom: 2px;" :class="formClassSet(b.isTrial)" v-if="!b.stewardsComment">
          <td
            style="font-size: 10px"
          >
            <div>
              <span v-if="b.finishingPosition === 1" style="font-weight:bold">{{b.finishingPosition}}</span><span v-else>{{b.finishingPosition}}</span> / {{b.starters}}
            </div>
            <div v-if="race.meeting.type !== 'HARNESS'">
              {{Math.abs(b.margin)}}L
            </div>
            <div v-if="race.meeting.type === 'HARNESS'">
              {{Math.abs(b.margin)}}m
            </div>
            <div style="white-space: nowrap">
              {{format(new Date(b.date), 'dd-MM-yy')}}
            </div>
          </td>
          <td
            style="font-size: 10px"
          >
            <div>
              {{b.track}}
            </div>
            <div style="max-width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
              {{checkClass(b.class)}}
            </div>
            <template v-if="!greyhoundMeeting(race)">
              <div
                v-if="!b.isTrial"
                style="font-size: 10px">
                ${{numeral(b.prizeTotal).format('0,0')}}
              </div>
              <div v-else>
                -
              </div>
            </template>
          </td>
          <td
            style="font-size: 10px"
          >
            <div>
              {{b.distance}}m
            </div>
            <div>
              {{formatToMinutes(b.elapsedTime)}}
            </div>
            <div>
              Days: {{b.dsls || '-'}}
            </div>
          </td>
          <td
            v-if="!greyhoundMeeting(race)"
            style="font-size: 10px"
          >
            <div>
              {{b.jockey}} ({{b.weight}}kg)
            </div>
            <div v-if="!greyhoundMeeting(race)">
              Bar: {{b.barrier}}
            </div>
            <div v-if="greyhoundMeeting(race)">
              Box: {{b.barrier}}
            </div>
            <div>
              1st: {{findWinnerForm(b) || `${runnerName.name} (${b.weight}kg)`}}
            </div>
          </td>
          <td
            v-if="!greyhoundMeeting(race) && !b.track.includes('Synthetic')"
            style="font-size: 10px">
            <div
              style="font-size: 10px"
              :class="['color-' + checkTrackCond(b.trackCondition)]">
              <b v-if="b.trackCondition === 'Unknown'">-</b>
              <b v-else>{{checkTrackCond(b.trackCondition)}}</b>
            </div>
            <div
              v-if="!b.isTrial" style="font-size: 10px;">
              ${{b.startingPrice.toFixed(2)}}
            </div>
            <div v-else> - </div>
          </td>
          <td
            v-else-if="!greyhoundMeeting(race) && b.track.includes('Synthetic')"
            style="font-size: 10px">
            <div
              style="font-size: 10px"
              :class="['color-Synthetic']">
              <b>Synthetic</b>
            </div>
            <div
              v-if="!b.isTrial" style="font-size: 10px;">
              ${{b.startingPrice.toFixed(2)}}
            </div>
            <div v-else> - </div>
          </td>
          <td
            v-if="greyhoundMeeting(race)"
            style="font-size: 10px">
            <div>
              1st: {{findWinnerFormGrey(b) || `${runnerName.name}`}}
            </div>
            <div
              v-if="!b.isTrial" style="font-size: 10px;">
              ${{b.startingPrice.toFixed(2)}}
            </div>
            <div v-else> - </div>
            <div
              style="font-size: 10px;">
              {{b.weight}}kg
            </div>
          </td>
        </tr>
        <!-- Show if there is a stewards comment -->
        <tr style="padding-bottom: 2px;" :class="formClassSet(b.isTrial)" v-if="b.stewardsComment">
          <td
            class="stewardsComment"
            style="font-size: 10px"
          >
            <div>
              <span v-if="b.finishingPosition === 1" style="font-weight:bold">{{b.finishingPosition}}</span><span v-else>{{b.finishingPosition}}</span> / {{b.starters}}
            </div>
            <div v-if="race.meeting.type !== 'HARNESS'">
              {{Math.abs(b.margin)}}L
            </div>
            <div v-if="race.meeting.type === 'HARNESS'">
              {{Math.abs(b.margin)}}m
            </div>
            <div style="white-space: nowrap">
              {{format(new Date(b.date), 'dd-MM-yy')}}
            </div>
          </td>
          <td
            class="stewardsComment"
            style="font-size: 10px"
          >
            <div>
              {{b.track}}
            </div>
            <div style="max-width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
              {{checkClass(b.class)}}
            </div>
            <template v-if="!greyhoundMeeting(race)">
              <div
                v-if="!b.isTrial"
                style="font-size: 10px">
                ${{numeral(b.prizeTotal).format('0,0')}}
              </div>
              <div v-else>
                -
              </div>
            </template>
          </td>
          <td
            class="stewardsComment"
            style="font-size: 10px"
          >
            <div>
              {{b.distance}}m
            </div>
            <div>
              {{formatToMinutes(b.elapsedTime)}}
            </div>
            <div>
              Days: {{b.dsls || '-'}}
            </div>
          </td>
          <td
            v-if="!greyhoundMeeting(race)"
            class="stewardsComment"
            style="font-size: 10px"
          >
            <div>
              {{b.jockey}} ({{b.weight}}kg)
            </div>
            <div v-if="!greyhoundMeeting(race)">
              Bar: {{b.barrier}}
            </div>
            <div v-if="greyhoundMeeting(race)">
              Box: {{b.barrier}}
            </div>
            <div>
              1st: {{findWinnerForm(b) || `${runnerName.name} (${b.weight}kg)`}}
            </div>
          </td>
          <td
            v-if="!greyhoundMeeting(race) && !b.track.includes('Synthetic')"
            style="font-size: 10px">
            <div
              style="font-size: 10px"
              :class="['color-' + checkTrackCond(b.trackCondition)]">
              <b v-if="b.trackCondition === 'Unknown'">-</b>
              <b v-else>{{checkTrackCond(b.trackCondition)}}</b>
            </div>
            <div
              v-if="!b.isTrial" style="font-size: 10px;">
              ${{b.startingPrice.toFixed(2)}}
            </div>
            <div v-else> - </div>
          </td>
          <td
            v-else-if="!greyhoundMeeting(race) && b.track.includes('Synthetic')"
            style="font-size: 10px">
            <div
              style="font-size: 10px"
              :class="['color-Synthetic']">
              <b>Synthetic</b>
            </div>
            <div
              v-if="!b.isTrial" style="font-size: 10px;">
              ${{b.startingPrice.toFixed(2)}}
            </div>
            <div v-else> - </div>
          </td>
          <td
            v-if="greyhoundMeeting(race)"
            style="font-size: 10px">
            <div>
              1st: {{findWinnerFormGrey(b) || `${runnerName.name}`}}
            </div>
            <div
              v-if="!b.isTrial" style="font-size: 10px;">
              ${{b.startingPrice.toFixed(2)}}
            </div>
            <div v-else> - </div>
            <div
              style="font-size: 10px;">
              {{b.weight}}kg
            </div>
          </td>
        </tr>
        <tr v-if="b.stewardsComment" style="background-color: #f2f2f2">
          <td style="font-size: 10px;" colspan="5">
            Stewards: {{b.stewardsComment}}
          </td>
        </tr>
        <tr style="background-color: #f2f2f2">
          <td style="text-align: center" colspan="5" v-if="b.dsls && b.dsls >= 42">
            <b style="color: grey; font-size: 10px !important;">---{{b.dsls}} DAY {{checkSpell(b.dsls)}}---</b>
          </td>
        </tr>
        </tbody>
      </v-simple-table>
      <div style="margin-left: 20px" v-else>
        <h3>First Start</h3>
      </div>
      <div class="mt-1">
        <v-btn
          dark
          small
          class="primaryCol"
          style="margin-left: 2%; margin-right: 2%"
          width="96%"
          @click="showMore = false"
          v-if="runnerHasPastStartsDO(runnerTabNo) && showAllDataForm(runnerForm).length > 10">
          Show Less
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns'
import ordinal from 'ordinal'
import numeral from 'numeral'

export default {
  name: 'RunnerStartsColumns',
  props: {
    runnerName: Object,
    race: Object,
    runnerForm: Array,
    runnerTabNo: Number
  },
  data () {
    return {
      numeral,
      format,
      ordinal,
      showMore: false
    }
  },
  methods: {
    formatInRun (inRun) {
      return inRun.split('()').join('').split(',').join('-')
    },
    thoroughbredMeeting (data) {
      return data.meeting.type === 'THOROUGHBRED'
    },
    harnessMeeting (data) {
      return data.meeting.type === 'HARNESS'
    },
    greyhoundMeeting (data) {
      return data.meeting.type === 'GREYHOUND'
    },
    numberOfStarts (form) {
      return form.length - 10
    },
    findSpellCurrent (data) {
      const latestForm = data[0]
      const latestFormDate = latestForm.date
      const todaysDate = new Date(this.race.startTime)
      const isoTodaysDate = todaysDate.toISOString()
      const formMilli = new Date(latestFormDate).getTime()
      const todayMilli = new Date(isoTodaysDate).getTime()
      const timeBetween = todayMilli - formMilli
      const daysBetween = timeBetween / (1000 * 60 * 60 * 24)
      const daysFormatted = Math.floor(daysBetween)
      return daysFormatted
    },
    formClassSet (v) {
      switch (v) {
        case true:
          return 'btrialColor'
        case false:
          return ''
        case '':
          return ''
      }
    },
    formatToMinutes (time) {
      const minutes = Math.floor(time / 60000)
      const seconds = ((time % 60000) / 1000).toFixed(2)
      if (this.race.meeting.type === 'GREYHOUND') {
        return (seconds < 10 ? '0' : '') + seconds
      } else {
        return minutes + ':' + (seconds < 10 ? '0' : '') + seconds
      }
    },
    checkMargin (margin, race) {
      let newMargin = ''
      if (margin === 0) {
        race.forEach(d => {
          if (d.finalPosition === 2) {
            newMargin = d.margin
          }
        })
      }
      return newMargin
    },
    findWinnerForm (data) {
      let winnerName = ''
      data.placeGetters.forEach((b) => {
        if (b.finishingPosition === 1) {
          if (this.harnessMeeting) winnerName = `${b.name}`
          else winnerName = `${b.name} (${b.weight}kg)`
        }
      })
      return winnerName
    },
    findWinnerFormGrey (data) {
      let winnerName = ''
      data.placeGetters.forEach((b) => {
        if (b.finishingPosition === 1) {
          winnerName = `${b.name}`
        }
      })
      return winnerName
    },
    findWinner (data) {
      let winnerName = ''
      data.forEach(d => {
        if (d.finalPosition === 1) {
          winnerName = `${d.name} (${d.weightTotal}kg)`
        }
      })
      return winnerName
    },
    mutateData (data) {
      // eslint-disable-next-line array-callback-return
      data.map((b, index) => {
        if (
          // eslint-disable-next-line eqeqeq
          b.race.status != 'ABANDONED' &&
          !b.scratched &&
          !this.runningToday(b)
        ) {
          if (index !== data.length - 1) {
            const nowTime = data[index].race.startTime
            const pastTimer = data[index + 1].race.startTime
            const nowTimeMili = new Date(nowTime).getTime()
            const pastTimeMili = new Date(pastTimer).getTime()
            const timeBetween = nowTimeMili - pastTimeMili
            const daysBetween = timeBetween / (1000 * 60 * 60 * 24)
            const daysFormatted = Math.floor(daysBetween)
            b.dsls = daysFormatted
          }
        }
      })
      return data
    },
    mutateDataForm (data) {
      const formattedData = data.filter(b => !b.isTrial)
      // eslint-disable-next-line array-callback-return
      formattedData.map((b, index) => {
        if (index !== formattedData.length - 1) {
          const nowTime = formattedData[index].date
          const pastTimer = formattedData[index + 1].date
          const nowTimeMili = new Date(nowTime).getTime()
          const pastTimeMili = new Date(pastTimer).getTime()
          const timeBetween = nowTimeMili - pastTimeMili
          const daysBetween = timeBetween / (1000 * 60 * 60 * 24)
          const daysFormatted = Math.floor(daysBetween)
          b.dsls = daysFormatted
        }
      })
      return this.race.meeting.track.country === 'JPN' || this.race.meeting.track.type === 'GREYHOUND' || this.race.meeting.track.type === 'HARNESS' ? data.slice(0, 10) : data.slice(0, 10).filter((a) => a.starters > 0)
    },
    showAllDataForm (data) {
      const formattedData = data.filter(b => !b.isTrial)
      // eslint-disable-next-line array-callback-return
      formattedData.map((b, index) => {
        if (index !== formattedData.length - 1) {
          const nowTime = formattedData[index].date
          const pastTimer = formattedData[index + 1].date
          const nowTimeMili = new Date(nowTime).getTime()
          const pastTimeMili = new Date(pastTimer).getTime()
          const timeBetween = nowTimeMili - pastTimeMili
          const daysBetween = timeBetween / (1000 * 60 * 60 * 24)
          const daysFormatted = Math.floor(daysBetween)
          b.dsls = daysFormatted
        }
      })
      return data
    },
    isMobile () {
      /* eslint-disable */
      let check = false;
      (function(a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },
    checkClass: function(x) {
      if (x.includes("Benchmark", "HANDICAP")) {
        const [first, second] = x.split(",");
        if (second === undefined) {
          const [a, b] = first.split(" ");
          return `BM ${b}`;
        }
        if (second === "HANDICAP=TRUE" || second === "HANDICAP=FALSE") {
          const [a, b] = first.split(" ");
          return `BM ${b}, HCP`;
        }
      }
      if (x.includes("HANDICAP=TRUE")) {
        // eslint-disable-next-line no-unused-vars
        const [first, second] = x.split(",");
        return `${first}, HCP`;
      }
      if (x.includes("HANDICAP=FALSE")) {
        // eslint-disable-next-line no-unused-vars
        const [first, second] = x.split(",");
        return `${first}`;
      }
      if (x.includes("Benchmark")) {
        const [first, second] = x.split(" ");
        return `BM ${second}`;
      }
      if (x.includes("Group l")) {
        return "Open,Group 1";
      }
      return x;
    },
    checkFinalPos(pos) {
      if (pos === 0) {
        return "*";
      } else {
        return pos;
      }
    },
    checkSpell(dsls) {
      if (dsls >= 21 && dsls <= 41) {
        return "FRESHEN";
      } else if (dsls >= 42 && dsls <= 83) {
        return "LET UP";
      } else if (dsls >= 84) {
        return "SPELL";
      }
    },
    totalRunners(d) {
      const runnerNo = d.race.competitors.length;
      const scratched = d.race.competitors.filter(b => b.scratched === true);
      const scratchNo = scratched.length;
      return runnerNo - scratchNo;
    },
    runningToday(d) {
      if (
        this.race.name === d.race.name &&
        this.race.startTime === d.race.startTime
      ) {
        return true;
      }
      return false;
    },
    runningFuture(d) {
      const psMilli = new Date(d.startTime);
      const csMilli = new Date(this.race.startTime);
      const pastStartTime = psMilli.getTime();
      const currStartTime = csMilli.getTime();
      if (pastStartTime > currStartTime) {
        return true;
      }
      return false;
    },
    runnerHasPastStartsDO() {
      return this.runnerForm.length >= 1
    },
    runnerHasPastStarts() {
      const pastStarts = this.runnerName.runner.competitorsConnection
        .competitors;
      const competitorList = [];
      pastStarts.forEach(d => competitorList?.push(d.scratched, d.race.status));
      if (
        pastStarts.length > 1 &&
        competitorList.status !== "ABANDONED" &&
        !competitorList.scratched
      ) {
        return true;
      }
      return false;
    },
    checkTrackCond: function(condition) {
      switch (condition) {
        case "FIRM1":
          return "Firm 1";
        case "Firm1":
          return "Firm 1";
        case "FIRM2":
          return "Firm 2";
        case "Firm2":
          return "Firm 2";
        case "GOOD3":
          return "Good 3";
        case "Good3":
          return "Good 3";
        case "GOOD4":
          return "Good 4";
        case "Good4":
          return "Good 4";
        case "SOFT5":
          return "Soft 5";
        case "Soft5":
          return "Soft 5";
        case "SOFT6":
          return "Soft 6";
        case "Soft6":
          return "Soft 6";
        case "SOFT7":
          return "Soft 7";
        case "Soft7":
          return "Soft 7";
        case "HEAVY8":
          return "Heavy 8";
        case "Heavy8":
          return "Heavy 8";
        case "HEAVY9":
          return "Heavy 9";
        case "Heavy9":
          return "Heavy 9";
        case "HEAVY10":
          return "Heavy 10";
        case "Heavy10":
          return "Heavy 10";
        case 'HEAVY11':
          return 'Heavy 11';
        case 'Heavy11':
          return 'Heavy 11';        
        case "SYNTHETIC" || "Synthetic":
          return "Synthetic";
        default:
          return condition;
      }
    }
  }
};
</script>

<style scoped>
.simpleTable td {
  height: 25px !important;
  font-size: 12px !important;
  white-space: nowrap !important;
}
.stewardsComment {
  border-bottom: none !important;
}
.btrialColor {
  color:rgb(179, 179, 179);
}
.v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > td {
  padding-left: 5px;
  padding-right: 0;
}
.v-data-table--dense > .v-data-table__wrapper > table > thead > tr > th {
  padding-left: 5px;
  padding-right: 0;
}
/*tr:nth-child(even) {*/
/*  background-color: #f2f2f2;*/
/*}*/

.color-Firm {
  color: rgb(0, 204, 255);
}
.color-Firm1 {
  color: rgb(0, 204, 255);
}
.color-Firm2 {
  color: rgb(0, 204, 255);
}
.color-Good {
  color: rgb(0, 219, 0);
}
.color-Good3 {
  color: rgb(0, 219, 0);
}
.color-Good4 {
  color: rgb(0, 219, 0);
}
.color-Soft {
  color: rgb(224, 210, 56);
}
.color-Soft5 {
  color: rgb(224, 210, 56);
}
.color-Soft6 {
  color: rgb(224, 210, 56);
}
.color-Soft7 {
  color: rgb(224, 210, 56);
}
.color-Heavy {
  color: orange;
}
.color-Heavy8 {
  color: orange;
}
.color-Heavy9 {
  color: orange;
}
.color-Heavy10 {
  color: orange;
}
.color-Heavy11 {
  color: orange;
}
.color-Synthetic {
  color: purple;
}
.tableHeaders {
  font-size: 14px;
  line-height: 14px;
}
</style>
